// extracted by mini-css-extract-plugin
module.exports = {"upgradeHover":"privacy-section_upgradeHover_ASd"};